import { Button } from '@chakra-ui/react'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRouter } from 'next/router'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import RPC from '@/client/rpc'

import { useToaster } from '@/components/Toast/useToaster'
import Tippy from '@/components/UI/Tippy'

export default function ApproveButton({
  id,
  onApprove,
  requiresChangesBeforeReview,
}: {
  id: number
  onApprove?: () => void
  requiresChangesBeforeReview: boolean
}): JSX.Element {
  const router = useRouter()
  const toast = useToaster()
  const [onClick, isApproving] = useAPIWrapper(
    async () => {
      toast({
        status: 'info',
        title: 'Approving volunteer hours...',
      })
      await RPC.admin_approveVolunteerHours({ id })
      await router.replace(router.asPath, undefined, { scroll: false })
      if (onApprove != null) {
        onApprove()
      }
      toast({
        status: 'success',
        title: 'Successfully approved volunteer hours!',
      })
    },
    [id, onApprove, router, toast],
    'Approve Volunteer Hours'
  )

  return (
    <Tippy
      content={
        requiresChangesBeforeReview
          ? 'Cannot approve this activity until changes have been addressed.'
          : 'This activity has been updated since its last review.'
      }
    >
      <Button
        onClick={onClick}
        rightIcon={<FontAwesomeIcon icon={faCheck} />}
        isLoading={isApproving}
        isDisabled={requiresChangesBeforeReview}
      >
        Approve
      </Button>
    </Tippy>
  )
}
